import { useState, useEffect, useCallback } from 'react';

interface GalleryImage {
  id: number;
  src: string;
  title: string;
  category: string;
  description: string;
}

const galleryImages: GalleryImage[] = [
  {
    id: 1,
    src: "https://public.readdy.ai/ai/img_res/876be09290cb8275f6a027160a843de1.jpg",
    title: "Torre Residencial Polanco",
    category: "Residencial Premium",
    description: "Estructura de 32 niveles con sistema de cimentación profunda y núcleo de concreto de alta resistencia."
  },
  {
    id: 2,
    src: "https://readdy.ai/api/search-image?query=Deep%20foundation%20Milan%20Wall%20excavation%20construction%20site%20massive%20concrete%20retaining%20walls%20heavy%20machinery%20industrial%20scale%20engineering%20project%20dramatic%20lighting%20construction%20excellence%20professional%20photography&width=800&height=600&seq=gallery-gcp-002&orientation=landscape",
    title: "Cimentación Encuentro Oceanía",
    category: "Cimentación Profunda",
    description: "54,000 m³ de excavación con Muro Milán. Proyecto de ingeniería de alta complejidad ejecutado en tiempo récord."
  },
  {
    id: 3,
    src: "https://readdy.ai/api/search-image?query=Luxury%20retail%20boutique%20interior%20construction%20high-end%20finishes%20marble%20floors%20premium%20materials%20elegant%20architecture%20sophisticated%20lighting%20professional%20photography%20dark%20moody%20atmosphere%20golden%20accents&width=800&height=600&seq=gallery-gcp-003&orientation=landscape",
    title: "Boutique Cartier Masaryk",
    category: "Retail de Lujo",
    description: "Adecuación integral de 600 m² con acabados de lujo, mármol importado y sistemas de iluminación de alta gama."
  },
  {
    id: 4,
    src: "https://readdy.ai/api/search-image?query=Premium%20residential%20apartment%20building%20facade%20completed%20modern%20architecture%20high-end%20finishes%20elegant%20exterior%20glass%20curtain%20wall%20night%20illumination%20dramatic%20lighting%20sophisticated%20design%20urban%20luxury&width=800&height=600&seq=gallery-gcp-004&orientation=landscape",
    title: "Calderón de la Barca 93",
    category: "Residencial Premium",
    description: "Conjunto residencial de 2,293 m² con departamentos de lujo, acabados premium y amenidades de primer nivel."
  },
  {
    id: 5,
    src: "https://readdy.ai/api/search-image?query=Professional%20sports%20court%20rehabilitation%20acrylic%20coating%20perfect%20lines%20chain%20link%20fence%20LED%20lighting%20athletic%20facility%20renovation%20dramatic%20nighttime%20lighting%20sports%20infrastructure%20excellence%20premium%20quality%20finish&width=800&height=600&seq=gallery-gcp-005&orientation=landscape",
    title: "Complejo Deportivo CDMX",
    category: "División Deportiva",
    description: "Rehabilitación de 12 canchas con recubrimientos acrílicos certificados NMX, iluminación LED y seguridad perimetral."
  },
  {
    id: 6,
    src: "https://readdy.ai/api/search-image?query=Large%20scale%20commercial%20construction%20project%20steel%20structure%20framework%20workers%20safety%20equipment%20industrial%20building%20under%20construction%20dramatic%20sky%20professional%20engineering%20photography%20cinematic%20lighting&width=800&height=600&seq=gallery-gcp-006&orientation=landscape",
    title: "Centro Comercial Santa Fe",
    category: "Obra Civil",
    description: "Estructura metálica de 18,000 m² con sistema de losa colaborante y fachada de vidrio templado."
  },
  {
    id: 7,
    src: "https://readdy.ai/api/search-image?query=Luxury%20penthouse%20apartment%20interior%20construction%20premium%20finishes%20marble%20floors%20floor%20to%20ceiling%20windows%20city%20view%20high%20rise%20building%20elegant%20sophisticated%20design%20professional%20photography&width=800&height=600&seq=gallery-gcp-007&orientation=landscape",
    title: "Penthouse Lomas de Chapultepec",
    category: "Residencial Premium",
    description: "Penthouse de 480 m² con acabados de autor, ventanales de piso a techo y terraza privada con vista panorámica."
  },
  {
    id: 8,
    src: "https://readdy.ai/api/search-image?query=Urban%20highway%20infrastructure%20viaduct%20construction%20aerial%20view%20massive%20concrete%20pillars%20steel%20beams%20engineering%20project%20dramatic%20lighting%20modern%20infrastructure%20city%20development%20professional%20photography&width=800&height=600&seq=gallery-gcp-008&orientation=landscape",
    title: "Viaducto Bicentenario",
    category: "Infraestructura Urbana",
    description: "Cuantificación y generadores en 54 km de infraestructura vial urbana de alta complejidad técnica."
  },
  {
    id: 9,
    src: "https://readdy.ai/api/search-image?query=Modern%20office%20building%20interior%20construction%20open%20plan%20workspace%20premium%20finishes%20polished%20concrete%20floors%20exposed%20ceiling%20industrial%20chic%20design%20professional%20photography%20dramatic%20lighting%20corporate%20architecture&width=800&height=600&seq=gallery-gcp-009&orientation=landscape",
    title: "Torre Corporativa Insurgentes",
    category: "Obra Civil",
    description: "Adecuación de 8,500 m² de espacios corporativos con diseño biofílico y sistemas de eficiencia energética."
  }
];

const categories = ["Todos", "Residencial Premium", "Cimentación Profunda", "Retail de Lujo", "División Deportiva", "Obra Civil", "Infraestructura Urbana"];

export default function GallerySection() {
  const [activeCategory, setActiveCategory] = useState("Todos");
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [imageLoaded, setImageLoaded] = useState(false);

  const filtered = activeCategory === "Todos"
    ? galleryImages
    : galleryImages.filter(img => img.category === activeCategory);

  const openLightbox = (index: number) => {
    setCurrentIndex(index);
    setImageLoaded(false);
    setLightboxOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = useCallback(() => {
    setLightboxOpen(false);
    document.body.style.overflow = '';
  }, []);

  const goNext = useCallback(() => {
    setImageLoaded(false);
    setCurrentIndex(prev => (prev + 1) % filtered.length);
  }, [filtered.length]);

  const goPrev = useCallback(() => {
    setImageLoaded(false);
    setCurrentIndex(prev => (prev - 1 + filtered.length) % filtered.length);
  }, [filtered.length]);

  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (!lightboxOpen) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowRight') goNext();
      if (e.key === 'ArrowLeft') goPrev();
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [lightboxOpen, closeLightbox, goNext, goPrev]);

  useEffect(() => {
    setCurrentIndex(0);
  }, [activeCategory]);

  const currentImage = filtered[currentIndex];

  return (
    <section id="galeria" className="py-24 bg-[#0F172A]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <p className="text-[#D4AF37] text-xs font-semibold uppercase tracking-[0.3em] mb-3">Obra Terminada</p>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">Galería de Proyectos</h2>
          <p className="text-[#E2E8F0] text-lg font-light max-w-3xl mx-auto">
            Cada imagen es evidencia de nuestra precisión técnica y excelencia constructiva
          </p>
        </div>

        {/* Filtros de categoría */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {categories.map(cat => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-300 cursor-pointer whitespace-nowrap border ${
                activeCategory === cat
                  ? 'bg-[#D4AF37] text-[#0F172A] border-[#D4AF37] shadow-lg shadow-[#D4AF37]/30'
                  : 'bg-transparent text-[#E2E8F0] border-white/10 hover:border-[#D4AF37]/50 hover:text-[#D4AF37]'
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Grid de imágenes */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {filtered.map((image, index) => (
            <div
              key={image.id}
              onClick={() => openLightbox(index)}
              className="group relative bg-[#18181B] rounded-xl overflow-hidden border border-white/5 hover:border-[#D4AF37]/50 transition-all duration-400 cursor-pointer hover:shadow-2xl hover:shadow-[#D4AF37]/10 hover:-translate-y-1"
            >
              <div className="relative h-60 w-full overflow-hidden">
                <img
                  src={image.src}
                  alt={image.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                />
                {/* Overlay hover */}
                <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A]/90 via-[#0F172A]/20 to-transparent opacity-60 group-hover:opacity-90 transition-opacity duration-300"></div>
                {/* Ícono de zoom */}
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#D4AF37]/20 border border-[#D4AF37]/60 backdrop-blur-sm">
                    <i className="ri-zoom-in-line text-[#D4AF37] text-2xl"></i>
                  </div>
                </div>
                {/* Badge categoría */}
                <div className="absolute top-3 left-3">
                  <span className="bg-[#D4AF37]/90 text-[#0F172A] text-xs font-bold px-3 py-1 rounded-full">
                    {image.category}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-white font-semibold text-base mb-1 group-hover:text-[#D4AF37] transition-colors">{image.title}</h3>
                <p className="text-[#E2E8F0]/60 text-xs font-light leading-relaxed line-clamp-2">{image.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Contador */}
        <div className="text-center mt-8">
          <p className="text-[#E2E8F0]/40 text-sm font-light">
            Mostrando <span className="text-[#D4AF37] font-semibold">{filtered.length}</span> proyectos
            {activeCategory !== "Todos" && <> en <span className="text-[#D4AF37] font-semibold">{activeCategory}</span></>}
          </p>
        </div>
      </div>

      {/* Lightbox */}
      {lightboxOpen && currentImage && (
        <div
          className="fixed inset-0 z-[100] flex items-center justify-center bg-black/95 backdrop-blur-sm"
          onClick={closeLightbox}
        >
          {/* Contenedor principal — detiene propagación */}
          <div
            className="relative w-full max-w-5xl mx-4 flex flex-col"
            onClick={e => e.stopPropagation()}
          >
            {/* Barra superior */}
            <div className="flex items-center justify-between mb-4 px-1">
              <div>
                <span className="text-[#D4AF37] text-xs font-semibold uppercase tracking-widest">{currentImage.category}</span>
                <h3 className="text-white text-xl font-bold mt-0.5">{currentImage.title}</h3>
              </div>
              <div className="flex items-center gap-4">
                <span className="text-[#E2E8F0]/50 text-sm">{currentIndex + 1} / {filtered.length}</span>
                <button
                  onClick={closeLightbox}
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 text-white transition-colors cursor-pointer"
                  aria-label="Cerrar galería"
                >
                  <i className="ri-close-line text-xl"></i>
                </button>
              </div>
            </div>

            {/* Imagen */}
            <div className="relative rounded-xl overflow-hidden bg-[#18181B] border border-white/10">
              {!imageLoaded && (
                <div className="absolute inset-0 flex items-center justify-center bg-[#18181B]">
                  <div className="w-10 h-10 border-2 border-[#D4AF37]/30 border-t-[#D4AF37] rounded-full animate-spin"></div>
                </div>
              )}
              <img
                src={currentImage.src}
                alt={currentImage.title}
                onLoad={() => setImageLoaded(true)}
                className={`w-full max-h-[65vh] object-cover object-top transition-opacity duration-300 ${imageLoaded ? 'opacity-100' : 'opacity-0'}`}
              />
              {/* Flechas de navegación */}
              <button
                onClick={goPrev}
                className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center rounded-full bg-black/50 hover:bg-[#D4AF37]/80 text-white hover:text-[#0F172A] border border-white/10 hover:border-[#D4AF37] transition-all duration-200 cursor-pointer backdrop-blur-sm"
                aria-label="Imagen anterior"
              >
                <i className="ri-arrow-left-s-line text-2xl"></i>
              </button>
              <button
                onClick={goNext}
                className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center rounded-full bg-black/50 hover:bg-[#D4AF37]/80 text-white hover:text-[#0F172A] border border-white/10 hover:border-[#D4AF37] transition-all duration-200 cursor-pointer backdrop-blur-sm"
                aria-label="Imagen siguiente"
              >
                <i className="ri-arrow-right-s-line text-2xl"></i>
              </button>
            </div>

            {/* Descripción */}
            <div className="mt-4 px-1">
              <p className="text-[#E2E8F0]/70 text-sm font-light leading-relaxed">{currentImage.description}</p>
            </div>

            {/* Miniaturas */}
            <div className="flex gap-2 mt-5 overflow-x-auto pb-1 scrollbar-hide">
              {filtered.map((img, idx) => (
                <button
                  key={img.id}
                  onClick={() => { setImageLoaded(false); setCurrentIndex(idx); }}
                  className={`flex-shrink-0 w-16 h-12 rounded-lg overflow-hidden border-2 transition-all duration-200 cursor-pointer ${
                    idx === currentIndex ? 'border-[#D4AF37] opacity-100' : 'border-transparent opacity-40 hover:opacity-70'
                  }`}
                  aria-label={`Ver ${img.title}`}
                >
                  <img src={img.src} alt={img.title} className="w-full h-full object-cover object-top" />
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
